var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#D1FADF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.75 33.0002L31.25 36.5002L38.25 29.5002M44.6666 33.0002C44.6666 39.4435 39.4433 44.6668 33 44.6668C26.5567 44.6668 21.3333 39.4435 21.3333 33.0002C21.3333 26.5568 26.5567 21.3335 33 21.3335C39.4433 21.3335 44.6666 26.5568 44.6666 33.0002Z",
    stroke: "#039855",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#ECFDF3",
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/greenTick.b491459a56286027ba3abd06d29bb642.svg";
export { ForwardRef as ReactComponent };